import { getLocaleByUrl } from "@/utils/locale";

export const locale = getLocaleByUrl();
